<template>
  <div :id="chartsId" style="width:100%;height:100%;"></div>
</template>

<script>
export default {
  name: 'gaugeChart',
  data() {
    return {
      myChart: '',
    }
  },
  props: ["chartsId", "data"],
  watch: {
    data(newValue, oldValue) {
      let newV = 0;
      if (newValue < 0) {
        newV = 0;
      } else {
        newV = newValue;
      }
      this.myChart.setOption({
        series: [{
          axisLine: {
            show: true,
            // 属性lineStyle控制线条样式
            lineStyle: {
              width: 30,
              color: [[newV / 100, '#3FB393'], [1, '#bebdbd']]    // 需要将百分比转换成小数
            }
          },
          data: [{
            value: newV
          }]
        }]
      });
    }
  },
  methods: {
    echarts() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById(this.chartsId))

      // 绘制图表
      let newV = 0;
      if (this.data < 0) {
        newV = 0;
      } else {
        newV = this.data;
      }
      this.myChart.setOption({
        tooltip: {
          formatter: '{c}%'
        },
        backgroundColor: '#ffffff',
        // series: [{
        //   radius: "90%", //仪表大小
        //   axisLine: {
        //     lineStyle: {
        //       color: [
        //         [1, '#3FB393']
        //       ],
        //       width: 15
        //     },
        //     width: 2,
        //   },
        //   splitLine:{
        //     length:15
        //   },
        //   axisTick: {
        //     show: true,
        //     length : 5
        //   },
        //   type: 'gauge',
        //   detail: {
        //     fontSize: 16,
        //     formatter: '{value}%'
        //   },
        //   data: [{
        //     value: newV
        //   }]
        // }],
        series: [{
          //类型
          type: 'gauge',
          //半径
          radius: 100,
          //起始角度。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
          startAngle: 180,
          //结束角度。
          endAngle: 0,
          center: ['50%', '75%'],
          //仪表盘轴线相关配置。
          axisLine: {
            show: true,
            // 属性lineStyle控制线条样式
            lineStyle: {
              width: 30,
              color: [[newV / 100, '#3FB393'], [1, '#bebdbd']]    // 需要将百分比转换成小数
            }
          },
          //分隔线样式。
          splitLine: {
            show: false,
          },
          //刻度样式。
          axisTick: {
            show: false,
          },
          //刻度标签。
          axisLabel: {
            color: '#000000',
            fontSize: 20,
            length: 15,
            formatter: function (value) {
              let texts = [];
              if (value == 0) {   // y轴刻度
                texts.push('0');
              } else if (value == 100) {
                texts.push('100');
              }
              return texts;
            },
          },
          //仪表盘指针。
          pointer: {
            show: false,
            //指针长度
            length: '90%',
            width: 0,  // 不显示仪表盘的指针
          },
          //仪表盘标题。
          title: {
            show: true,
            offsetCenter: ['20px', '40px'], // x, y，单位px
            textStyle: {
              color: '#000',
              fontSize: 30
            }
          },
          //仪表盘详情，用于显示数据。
          detail: {
            show: true,
            offsetCenter: [0, '-30%'],
            formatter: '{value}%',
            textStyle: {
              fontSize: 30,
              color: '#000',
            }
          },
          data: [{
            value: (newV > 100 ? 100 : newV),  //  正常回显百分比
          }],
        }]
      });
    },
  },
  mounted() {
    this.echarts();
  },
  created() {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/list/chart/gaugeChart.vue